module.exports = function(bh) {
    bh.match('form-check', function(ctx, json) {
        ctx.tParam('ID', ctx.generateId());
        const count = json?.props?.count;
				const inside = json?.props?.inside;
        if (count) delete json.props;
        const props = Object.assign({
            type: 'checkbox',
            value: ctx.generateId(),
        }, json.props ? json.props : {});
        const content = ctx.content();
        ctx.content([
            {elem: 'input', attrs: props},
            {elem: 'label', content: [
              content && [
								inside && [
									{tag: 'span', content: [
										content,
										count && {tag: 'var', content: count}
									]},
								],
								!inside && [
									{tag: 'span', content},
									count && {tag: 'var', content: count}
								]
              ]
            ]},
        ], true);
    });
};
